import { render, staticRenderFns } from "./MoreButton.vue?vue&type=template&id=1bf53b4a"
import script from "./MoreButton.vue?vue&type=script&lang=js"
export * from "./MoreButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports